import { OrganizationRoles } from "@/shared/utils/constants";

export const CAN_CREATE_REQUESTS = [
  OrganizationRoles.ADMIN.value,
  OrganizationRoles.SUPERVISOR.value,
];
